import React from 'react';
import AuthLayout from '../../layouts/AuthLayout';
import ResetPassword from '../../components/Auth/ResetPassword';

const ResetPasswordPage = () => {
	return (
		<AuthLayout>
			<ResetPassword />
		</AuthLayout>
	);
};

export default ResetPasswordPage;
